var e=typeof window<"u"&&typeof window.document<"u"&&typeof window.document.createElement<"u";export{e as default};
//# sourceMappingURL=can-use-dom.js.map
